import { AsnFormErrors, AsnPayload } from "./types";

export function validateAsn(asnItem: Partial<AsnPayload>): AsnFormErrors {
  const errors: AsnFormErrors = {};

  if (!asnItem.nome_asn?.toString().trim())
    errors.nome_asn = "Nome é obrigatório";

  const asn = asnItem.asn?.toString().trim();
  if (asn && !/^\d+$/.test(asn)) errors.asn = "Informe apenas números";

  return errors;
}
